export const imgLogoGalicia =
  "https://www.galiciaseguros.com.ar/media-library/Templates/images/logo.png";
export const imgLogoInsideOne =
  "https://i.postimg.cc/R0RvH3TJ/insideone-isologo.png";
export const imgLogoPlataforma5 =
  "https://www.plataforma5.la/static/media/LogoP5Mobile.a55e0d3ded6702e47da325ac762d2f5d.svg";
